<template lang="pug">
  .b-date-progress
    BaseProgressbar._progressbar(
      v-bind="dateProgress"
      @clickStart="$refs.dpStart && $refs.dpStart.open()"
      @clickFinish="$refs.dpFinish && $refs.dpFinish.open()"
    )
    template(v-if="editable")
      BaseDatepicker._datepicker.-start(
        :type="dpType",
        @input="dateChanged('Start', $event)"
        :value="dateProgress['dateStartIso']"
        hidden
        ref="dpStart"
      )
      BaseDatepicker._datepicker.-finish(
        :type="dpType",
        @input="dateChanged('Finish', $event)"
        :value="dateProgress['dateFinishIso']"
        hidden
        ref="dpFinish"
      )
</template>

<script>
import BaseProgressbar from '@/components/BaseProgressbar.vue';
import BaseDatepicker from '@/components/BaseDatepicker.vue';

export default {
  name: 'DateProgressbar',
  components: { BaseProgressbar, BaseDatepicker },
  props: {
    editable: Boolean,
    dateProgress: Object,
  },
  computed: {
    dpType() { return this.dateProgress.withTime ? 'datetime' : 'date'; },
  },
  methods: {
    dateChanged(position, value) {
      this.$emit('dateChange', { position, value });
    },
  },
};
</script>

<style scoped lang="scss">
  .date-progress {
    position: relative;

    &__datepicker {
      position: absolute;
      top: 50%;

      &--start {
        left: 0;
      }

      &--finish {
        right: 0;
      }
    }
  }
</style>
